import { IRootState } from '@/store/state';
import { Module, Store, StoreOptions } from 'vuex';
import { AssociateUserGetters } from './getters';
import { AssociateUserState, IAssociateUserState } from './state';
import { AssociateUserActions } from './actions';
import { AssociateUserMutations } from './mutations';

export const AssociateUserModuleStore: IAssociateUserModuleStore = {
  state: AssociateUserState,
  actions: AssociateUserActions,
  getters: AssociateUserGetters,
  mutations: AssociateUserMutations
};

/**
 * --------------------------------------------------
 *	Fund Store Interface
 * --------------------------------------------------
 **/
export interface IAssociateUserModuleStore
  extends Module<IAssociateUserState, IRootState> {}
